<template>
  <v-app id="ui" fluid app tag="section">
    <v-row justify="center" class="centerTop">
      <v-col cols="5">
        <base-material-card
          color="red"
          title="Forgot My Password"
          class="px-5 py-3"
          icon="mdi-lock-reset"
          id="white"
        >
          <Notification></Notification>

          <v-card-text class="px-0 pb-0">
            <v-sheet>
              <v-form ref="forgot">
                <v-text-field
                  label="Username"
                  hint="Username"
                  :rules="requiredRules"
                  v-model="username"
                  class="purple-input"
                />
              </v-form>
              <br />
              <v-row class="ma-0 pa-0">
                <v-col>
                  <v-btn
                    block
                    :loading="loading"
                    :disabled="loading"
                    @click="changePass"
                    color="deep-orange"
                  >Reset Password</v-btn>
                </v-col>
                <v-col>
                  <v-btn block outlined to="/">Back to Login</v-btn>
                </v-col>
              </v-row>
              <br />
            </v-sheet>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>

    <template slot="default">
      <div id="bg"></div>
      <div id="overlay"></div>
    </template>
  </v-app>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import moment from "moment";

export default {
  name: "ForgotPassword",
  components: {
    Notification: () => import("../components/Notification")
  },
  data() {
    return {
      username: "",
      loading: false,
      requiredRules: [
        v => !!v || "Username is required",
        // v => /.+@.+\..+/.test(v) || "Email must be a valid address"
      ],
      notification: []
    };
  },
  methods: {
    ...mapMutations(["SET_NOTIFICATION"]),
    setNotification(t, m) {
      this.notification["msg"] = m;
      this.notification["type"] = t;
      this.$store.commit("SET_NOTIFICATION", this.notification);
    },
    changePass() {
      if (this.$refs.forgot.validate()) {
        this.loading = true;
        this.$http
          .post("/change_password", {
            username: this.username
          })
          .then(res => { 
            if (res.status == 200) { 
              if (res.data.resultDesc == "Error") {
                this.setNotification("error", res.data.payload);
              } else {
                this.setNotification("success", res.data.payload);
                this.$router.push("/");
              }
            } else {
              this.setNotification(
                "error",
                "Failed to reset password. Please try again."
              );
              this.loading = false;
            }
            this.loading = false;
          })
          .catch(err => {
            this.setNotification(
              "error",
              "Failed to reset password. Please try again."
            );
            this.loading = false;
          }); 
      }
    }
  },
  computed: {
    ...mapState(["hasMessage", "message", "msgtype"])
  }
};
</script>

<style scoped>
#bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("../../assets/bg.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

#overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
}

#white {
  background: #fff !important;
  z-index: 102020;
  min-width: 200px;
}

.centerTop {
  margin-top: 8% !important;
}
</style>
